import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import css from './UnderRow.css';
import Icon from '../../../../components/foundations/Icon';
import Button from '../../../../components/atoms/Button';
import { TTypeEnum } from './consts';

const iconNameMap = {
    [TTypeEnum.ALERT]: 'alert-triangle',
};

const typeClassMap = {
    [TTypeEnum.ALERT]: css.underRowAlert,
};

const UnderRow = ({
    type = 'info',
    className = '',
    message,
    actionButtonText = '',
    onButtonClick,
    actionButton = null,
    ...props
}) => {
    const getIconName = () => {
        return iconNameMap[type] || null;
    };

    const getTypeClass = () => {
        return typeClassMap[type] || '';
    };
    return (
        <div className={classNames(css.underRowContainer, getTypeClass(), className)} {...props}>
            <div className={css.underRowContent}>
                <div className={classNames(css.underRowIconAndMessage, css.underRowIconAndMessageType)}>
                    <span className={css.underRowIcon}>
                        <Icon name={getIconName()} className={css.iconColor} />
                    </span>
                    <span className={css.underRowMessage}>
                        <Translate id={message} />
                    </span>
                    {actionButtonText && (
                        <Button type="secondary" onClick={onButtonClick}>
                            <Translate id={actionButtonText} />
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

UnderRow.propTypes = {
    type: PropTypes.oneOf(['alert', 'error', 'info']),
    message: PropTypes.string.isRequired,
    actionButton: PropTypes.node,
    className: PropTypes.string,
    onButtonClick: PropTypes.func,
    actionButtonText: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node),
};

export default UnderRow;
